export const resonance = {
  resonance_title: 'Resonance App',
  resonance_open_app_on_mobile: 'Ouvrir l\'application sur mobile',
  resonance_open_app_on_mobile_description: 'Pour une meilleure expérience, nous vous recommandons d\'utiliser l\'application mobile.',
  resonance_open_app_on_mobile_button: 'Ouvrir l\'application sur mobile',

};
